


































import Vue from 'vue'
import HomeDashboardTile from '@/components/HomeDashboardTile.vue'
import HomePhoneNumber from '@/components/HomePhoneNumber.vue'
import HomeDashboardTileType from '@/types/components/HomeDashboardTile.interface'
import { mapGetters } from 'vuex'
import { popNewMessage } from '@/utility/helpers'
import Analytics from '@/services/Analytics'
interface HomeSection {
    header: string
    component?: string
    tiles?: HomeDashboardTileType[]
    hidden?: boolean
}
export default Vue.extend({
    components: { HomeDashboardTile, HomePhoneNumber },
    mounted() {
        //  Check if we have a number form query param
        const getNumber = this.$route.query.getNumber

        //  If we don't, do nothing
        if (!getNumber) return

        //  Else, open our form with this type pre-selected
        this.popChooseNumber(getNumber)
    },
    computed: {
        ...mapGetters(['phoneOrder', 'smsAccount']),
        // Function pulls from api to get the settings data table to see if a user is a2p enabled or not
        a2pRegistered(): boolean {
            const a2pEnabled = this.$store.getters.settingGet('a2pEnabled')

            //  If our setting doesn't exist, return false
            if (!a2pEnabled) return false

            //  Else, return based on if we are enabled or not
            return !!a2pEnabled.enabled
        },
        homeSections(): HomeSection[] {
            return [
                {
                    header: 'Step 1: Get the Right Phone Number',
                    hidden: this.phoneOrder,
                    tiles: [
                        {
                            title: 'Your Temporary Phone Number',
                            description:
                                'You can use this temporary number during your 14-day free trial.',
                            text: this.phoneNumber,
                            large: true
                        },
                        {
                            title: 'Connect a Phone Number',
                            description:
                                'Select a brand new number, connect an existing phone line or request a toll-free number.',
                            button: {
                                text: 'Connect a Phone Number',
                                icon: 'bi-search',
                                highlight: true,
                                disabled: !this.$store.getters.userHasPermission(3),
                                callback: () => this.popChooseNumber()
                            }
                        }
                    ]
                },
                {
                    header: 'Step 1: Get the Right Phone Number',
                    hidden: !this.phoneOrder || this.phoneOrder.state === 'complete',
                    tiles: [
                        {
                            title: 'Connect a Landline or Migrate a Phone Number',
                            color: '#E7A730',
                            description:
                                'Integrate an existing phone number with MessageDesk. This process occurs within 48 hours.',
                            button: {
                                text: 'Request in Progress (Click to View)',
                                icon: 'bi-clock-fill',
                                color: '#FFDEA1',
                                textColor: '#E7A730',
                                highlight: true,
                                callback: () => this.popCheckOrder()
                            }
                        },
                        {
                            title: 'Your Temporary Phone Number',
                            color: '#E7A730',
                            description:
                                'You can use this temporary number during your 14-day free trial.',
                            text: this.phoneNumber,
                            large: true
                        }
                    ]
                },
                {
                    header: 'Step 1: Get the Right Phone Number',
                    component: 'home-phone-number',
                    hidden: !this.phoneOrder || this.phoneOrder.state !== 'complete'
                },
                // {
                //     header: 'Step 2: Start a Conversation',
                //     tiles: [
                //         {
                //             title: 'Inbox',
                //             description: 'Explore 1-on-1 texting in MessageDesk',
                //             button: {
                //                 text: 'Send a text',
                //                 icon: 'bi-arrow-right-circle-fill',
                //                 highlight: true,
                //                 callback: () => this.sendText()
                //             }
                //         },
                //         {
                //             title: 'Broadcast',
                //             description: 'Explore mass texting by composing a Broadcast',
                //             button: {
                //                 text: 'Compose a Broadcast',
                //                 icon: 'bi-arrow-right-circle-fill',
                //                 highlight: false,
                //                 callback: () => this.sendBroadcast()
                //             }
                //         }
                //     ]
                // },
                {
                    header: 'Step 2: Upload Contacts',
                    tiles: [
                        {
                            title: 'Add Contacts to MessageDesk',
                            description:
                                'Upload contacts with a .CSV, sync contacts from a CRM, or add them individually',
                            button: {
                                text: 'Add Contacts',
                                icon: 'bi-arrow-right-circle-fill',
                                highlight: false,
                                callback: () => this.addContacts()
                            }
                        }
                    ]
                },
                {
                    header: 'Step 3: Find the perfect solution for your needs',
                    tiles: [
                        {
                            title: 'Quick Start Videos',
                            description:
                                'Learn how to setup MessageDesk with our library of how-to videos',
                            button: {
                                text: 'Explore Videos',
                                icon: 'bi-arrow-right-circle-fill',
                                highlight: false,
                                callback: () => this.popExploreVideos()
                            }
                        }
                    ]
                }
            ]
        },
        phoneNumber(): string {
            //  Grab our sms account
            const account = this.smsAccount

            //  If no account, return 'n/a'
            if (!account) return 'N/A'

            //  Else, grab our msisdn
            const msisdn = account.msisdn

            //  Convert this to a human-readable format
            return this.$options.filters.phone(msisdn)
        }
    },
    methods: {
        addContacts(): void {
            this.$router.push('/contacts?showEmpty=true')
        },
        popCheckOrder(): void {
            //  Grab our current phone order
            const order = this.phoneOrder

            //  Grab the order's type
            const type = order.type

            //  Our component depends on the type of order we have
            const component = {
                backorder: 'backordered-number-info',
                hosting: 'host-number-info'
            }[type]

            //  Open our dialog
            this.$store.dispatch('dialogOpen', {
                type: 'APP',
                component: component,
                closeable: true,
                width: '820px',
                props: {
                    viewOnly: true
                }
            })
        },
        popChooseNumber(type: string): void {
            this.$store.dispatch('dialogOpen', {
                type: 'APP',
                component: 'choose-number-popup',
                closeable: true,
                closeOnSubmit: true,
                width: '820px',
                props: {
                    defaultType: type
                },
                callback: (type: string) => {
                    //  Report to analytics
                    Analytics.track('GetPhoneNumberCompleted', {
                        phone_number_type: type
                    })
                }
            })
        },
        popExploreVideos(): void {
            //  Our width depends on screen size
            const width = this.$vuetify.breakpoint.xsOnly ? '500px' : '850px'

            this.$store.dispatch('dialogOpen', {
                type: 'APP',
                component: 'explore-templates',
                closeOnSubmit: true,
                width: width
            })
        },
        sendBroadcast(): void {
            this.$router.push('/broadcasts/create')
        },
        sendText(): void {
            //  Route to inbox if we aren't already there
            this.$router.push('/inbox?newMessage=true')

            //  Pop the new message
            popNewMessage()
        }
    }
})
